import { Controller } from "@hotwired/stimulus";

import * as AgGrid from "ag-grid-community";
import { ColumnsState } from "grid/columns_state";

export class GridController<T> extends Controller {
  static targets = ["grid"];
  static values = {};

  declare readonly gridTarget: HTMLInputElement;
  declare readonly hasGridTarget: boolean;

  $resetGridBtn: HTMLButtonElement;
  gridApi: AgGrid.GridApi<T>;
  // headersI18n: { [key: string]: string };
  // paginationPageSize: number;

  override connect() {
    if (this.hasGridTarget) {
      // this.headersI18n = JSON.parse(this.gridTarget.dataset.i18nJson) // todo rename i18nJson to headersI18nJson
      // this.paginationPageSize = parseInt(this.gridTarget.dataset.paginationPageSize)

      this.gridApi = this.buildGrid();
      this.connectColumnsResetAction(this.element.querySelector(".reset-grid"));
    }
  }

  buildGrid(): AgGrid.GridApi<T> {
    return null;
  }

  // TODO: extract to ResetGridColumnsAction and combine with ColumnsState (like a plugin)
  private connectColumnsResetAction($resetGridBtn: HTMLButtonElement) {
    const columnsState = new ColumnsState(this.gridApi, this.identifier);
    columnsState.initialize();
    this.gridApi.addEventListener("columnResized", (event) => columnsState.onResize(event));
    $resetGridBtn.addEventListener("click", () => columnsState.reset());
  }

  override disconnect() {
    this.gridApi?.destroy();
  }
}
